<template>
  <div class="mask" v-if="dataVal.flag">
    <div class="mask-content">
      <div class="mask-content-header">
        <div>
          {{ dataVal.type == "edit1" ? "编辑个人任务" : "批量编辑个人任务" }}
        </div>
        <div @click="handleRefund">
          <el-icon name="close" size="16"></el-icon>
        </div>
      </div>
      <div class="mask-content-body" v-if="dataVal.type == 'edit1'">
        <div class="mask-content-body-info">
          <div>会员姓名：{{ item.nickname }}</div>
          <div>会员手机：{{ item.mobile }}</div>
          <div>当前任务目标：{{ item.targetcount }}</div>
        </div>
        <div class="mask-content-body-select">
          <div class="mask-content-body-select-title">
            最新目标<span>*</span>：
          </div>
          <div class="mask-content-body-select-input">
            <el-input
              v-model="fromData.targetcount"
              type="number"
              placeholder="请输入最新目标"
            ></el-input>
          </div>
        </div>
        <div class="mask-content-footer">
          <div @click="handleRefund">取消</div>
          <div @click="handleSubmit">确认</div>
        </div>
      </div>
      <div
        class="mask-content-body mask-content-body2"
        v-if="dataVal.type == 'edit2'"
      >
        <div class="mask-content-body-select">
          <div class="mask-content-body-select-title">
            最新目标<span>*</span>：
          </div>
          <div class="mask-content-body-select-input">
            <el-input
              v-model="fromData.targetcount"
              type="number"
              placeholder="请输入最新目标"
            ></el-input>
          </div>
        </div>
        <div class="mask-content-footer">
          <div @click="handleRefund">取消</div>
          <div @click="handleSubmit">确认</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddGroup",
  props: ["dataVal"],
  data() {
    return {
      fromData: {
        usertasklog_ids: "", //任务id,
        targetcount: "", //目标数量
      },
      item: {},
    };
  },
  mounted() {},
  methods: {
    //取消弹窗
    handleRefund() {
      let data = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("editTaskCall", data);
    },
    async handleSubmit() {
      let res = await this.$api.activityEditusertasklog({
        ...this.fromData,
      });
      if (res.code == 1) {
        let data = {
          flag: false, //弹窗是否显示
          submitFlag: true, //是否调用接口
        };
        this.$emit("editTaskCall", data);
      }
    },
  },
  watch: {
    dataVal: {
      handler(val) {
        if (val.type == "edit2") {
          this.fromData.usertasklog_ids = val.usertasklog_ids;
        } else {
          this.fromData.usertasklog_ids = val.item.id;
          this.item = val.item;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;

  .mask-content {
    width: 715px;
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
    position: fixed;

    .mask-content-header {
      width: 100%;
      min-height: 50px;
      background: #c12e30;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;

      div {
        color: var(--Gray-White, #fff);
        font-size: 16px;
      }

      .el-icon-close {
        color: #fff;
        cursor: pointer;
      }
    }

    .mask-content-body {
      width: 100%;
      background-color: #fff;
      padding: 20px 20px 34px 20px;

      .mask-content-body-info {
        width: 100%;
        height: 83px;
        border-radius: 3px;
        border: 1px solid #dcdcdc;
        background: #f3f3f3;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        div {
          color: rgba(0, 0, 0, 0.9);
          font-size: 14px;
          margin-left: 100px;

          &:nth-child(1) {
            margin-left: 0;
          }
        }
      }

      .mask-content-body-select {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .mask-content-body-select-title {
          width: 87px;
          color: #a6a6a6;
          font-size: 14px;
          display: flex;
          align-items: center;

          span {
            color: #c12e30;
          }
        }

        .mask-content-body-select-input {
          flex: 1;

          .el-select {
            width: 100%;
          }
        }
      }

      .mask-content-footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 474px;

        div {
          width: 120px;
          height: 40px;
          color: rgba(0, 0, 0, 0.9);
          font-size: 14px;
          border-radius: 5px 0 0 5px;
          background: #edc2c3;
          @include flex-center(center, center);
          cursor: pointer;

          &:nth-child(2) {
            border-radius: 0 5px 5px 0;
            color: rgba(255, 255, 255, 0.9);
            background: #b30003;
          }
        }
      }
    }

    .mask-content-body2 {
      .mask-content-footer {
        margin-top: 577px;
      }
    }
  }
}
</style>